import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getFeatureFlags,
  setFeatureFlagsAsSeen,
  setMspFeatureFlagsAsSeen,
} from "controller/api";
import { ApiErrorType } from "shared";
import { sentryLogger } from "utilz";
import { debugConsole } from "utilz/helpers";

export const useGetFeatureFlags = () => {
  return useQuery({
    queryKey: ["featureFlags"],
    queryFn: () => getFeatureFlags(),
    onError: (err) => debugConsole(err),
    staleTime: Infinity,
  });
};

export const useSetFeatureFlagAsSeen = () => {
  const queryClient = useQueryClient();
  return useMutation((feature: string) => setFeatureFlagsAsSeen(feature), {
    onSuccess: () => {
      queryClient.invalidateQueries(["featureFlags"]);
    },
    onError: (error: ApiErrorType, variable) => {
      sentryLogger({
        error: error,
        workflow: "common",
        level: "error",
        functionName: "setFeatureFlagsAsSeen",
      });
    },
  });
};

export const useSetMspFeatureFlagAsSeen = () => {
  const queryClient = useQueryClient();
  return useMutation((feature: string) => setMspFeatureFlagsAsSeen(feature), {
    onSuccess: () => {
      queryClient.invalidateQueries(["featureFlags"]);
    },
    onError: (error: ApiErrorType, variable) => {
      sentryLogger({
        error: error,
        workflow: "common",
        level: "error",
        functionName: "setMspFeatureFlagsAsSeen",
      });
    },
  });
};
